export default {
  SEARCH_PARAMS: 'SEARCH_PARAMS',
  SEARCH_SKU: 'SEARCH_SKU',
  SEARCH_PARAMS_CURRENT: 'SEARCH_PARAMS_CURRENT',
  SEARCH_PRODUCT_TYPE: 'SEARCH_PRODUCT_TYPE',
}
